module.exports = __webpack_public_path__ + "static/media/Seer_logo.f2b583b8.png";